<template>
  <div id="app">
        <router-view />
  </div>
</template>

<script>

// import { ref } from 'vue';
// import { useRouter } from 'vue-router';

export default {
  name: 'App',

  // setup() {
  //   const isLoggedIn = ref(false); // 初始状态是未登录
  //   const router = useRouter();

  //   // 登录处理
  //   const login = () => {
  //     isLoggedIn.value = true; // 设置为已登录
  //     router.push('/submit'); // 登录后跳转到提交资料页面
  //   };

  //   // 登出处理
  //   const logout = () => {
  //     isLoggedIn.value = false;
  //     router.push('/login'); // 登出后跳转到登录页面
  //   };

  //   return {
  //     isLoggedIn,
  //     login,
  //     logout
  //   };
  // }
};
</script>

<style>
html, body {
  height: 100%; /* 设置 html 和 body 高度为 100% */
  margin: 0; /* 去除默认边距 */
}

</style>